import { SelectOption } from 'ui';

const countryCodes = [
  'AU',
  'NZ',
  'US',
  'GB',
  'CA',
  'CN',
  'DE',
  'FR',
  'JP',
  'SG',
  'HK',
  'IE',
  'NL',
  'CH',
  'SE',
  'NO',
  'DK',
  'FI',
  'IT',
  'ES',
  'PT',
  'BE',
  'AT',
  'PL',
  'CZ',
  'SK',
  'HU',
  'GR',
  'RO',
  'BG',
  'HR',
  'SI',
  'EE',
  'LV',
  'LT',
  'LU',
  'IS',
  'LI',
  'MC',
  'MT',
  'CY',
  'BR',
  'MX',
  'AR',
  'CL',
  'CO',
  'PE',
  'UY',
  'PY',
  'VE',
  'IN',
  'PK',
  'BD',
  'LK',
  'TH',
  'VN',
  'MY',
  'ID',
  'PH',
  'KH',
  'LA',
  'MM',
  'TW',
  'KR',
  'AE',
  'SA',
  'QA',
  'KW',
  'BH',
  'OM',
  'TR',
  'ZA',
  'NG',
  'KE',
  'EG',
  'MA',
  'TN',
  'DZ',
  'ET',
  'GH',
  'UG',
  'TZ',
] as const;

const displayNames =
  typeof Intl !== 'undefined' && 'DisplayNames' in Intl
    ? new Intl.DisplayNames(['en'], { type: 'region' })
    : null;

export const countryOptions: SelectOption<string>[] = countryCodes.map(code => ({
  value: code,
  label: displayNames?.of(code) || code,
}));
